import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";

export const TableBottomSection = ({ updateConstraint, constraints, currentPage, totalPages }) => {
    console.log(totalPages)
    const nextPage = () => {
        updateConstraint(prev => ({
            ...prev,
            page: Math.min(prev.page + 1, totalPages), // Ensures page doesn't exceed totalPages
        }));
    };

    const previousPage = () => {
        updateConstraint(prev => ({
            ...prev,
            page: Math.max(prev.page - 1, 1), // Ensures page doesn't go below 1
        }));
    };

    return (
        <div className="w-full p-4 bg-gray-50 flex justify-between">
            <span>Page {currentPage} of {totalPages}</span>
            <div className="flex gap-2">
                <button
                    onClick={previousPage}
                    className="w-10 h-10 flex justify-center items-center cursor-pointer hover:bg-gray-200 duration-300 rounded"
                    disabled={constraints.page === 1}
                >
                    <IoIosArrowBack size={24} />
                </button>
                <button
                    onClick={nextPage}
                    className="w-10 h-10 flex justify-center items-center hover:bg-gray-200 duration-300 rounded"
                    disabled={constraints.page === totalPages}
                >
                    <IoIosArrowForward size={24} />
                </button>
            </div>
        </div>
    );
};
